<template>
  <div :class="{'zeborne': storeId === 2}">
    <!-- Modal calendar -->
    <transition name="slide-fade">
      <ModalCalendar
        v-show="showModalCalendar"
        :showModal="showModalCalendar"
        :class="'Modal-right'"
        @Modal::close="closeModalCalendar"
        :deliveryType="defaultSelectedShippingMethod"
        :fromLanding="true"
        :slotsChoiceActive="slotsChoiceActive"
        :landingLeadType="landingLeadType"
        :landingCategoryName="landingCategoryName"
      ></ModalCalendar>
    </transition>
  </div>
</template>

<script>

import store from "@/store";
import setStoreMixin from "@/mixins/setStoreMixin";
import getCartMixin from "@/mixins/actions/cart/getCartMixin";
import { mapGetters, mapActions } from "vuex";
import "@/assets/styles/mcp/_main.scss";
import "./Landing.scss";

// css from other components
import "@/components/Cart/CartRecap/CartRecap.scss";
import "@/includes/Product/ProductShippingMethods/ProductShippingMethods.scss";


import ModalCalendar from "@/components/Modal/ModalCalendar.vue";
import addItemToCartMixin from "@/mixins/actions/cart/addItemToCartMixin.js";
import storeCodeMixin from "@/mixins/storeCodeMixin";


import "@/globals.js";

export default {
  store,
  name: "Landing",

  components: {
    ModalCalendar
  },

  mixins: [
    setStoreMixin,
    getCartMixin,
    addItemToCartMixin,
    storeCodeMixin
  ],

  data() {
    return {
      showModalCalendar: false,
      defaultSelectedShippingMethod: 'intervention',
      leadType: "",
      landingCategoryName: "",
    };
  },

  computed: {
    ...mapGetters({ productBillInfo: "getProductBillInfo" }),
    ...mapGetters({ productCurrentTva: "getProductTVAForCurrentDelivery" }),
    ...mapGetters({ additionalInfo: "getPreprendCartAdditionalInfo" }),
    ...mapGetters({ storeId: "getStoreId", }),
    ...mapGetters({ preprendCartDataDelivery: "getPreprendCartDeliveryData", }),
  },

  beforeMount() {
    let productId = null;
    const landingProductId = window.landingProductId || productId;
    this.landingLeadType = window.landingLeadType;
    this.slotsChoiceActive = (window.slotsChoiceActive !== undefined ? !!window.slotsChoiceActive : true);
    this.landingCategoryName = window.landingCategoryName

    this.$store.state.Product.appProduct.id = landingProductId;
    document.addEventListener('lnd-open-calendar', () => {
      // re-do that because window.landingProductId isn't always already defined when beforeMount is called
      this.$store.state.Product.appProduct.id = window.landingProductId || productId;
      if(window.landingQa !== 0 ) this.initStrapiForm();
      this.landingLeadType = window.landingLeadType;
      this.landingCategoryName = window.landingCategoryName
      this.slotsChoiceActive = (window.slotsChoiceActive !== undefined ? !!window.slotsChoiceActive : true);

      this.addItemToCart(this.$store.state.Product.appProduct.id,1 , this.preprendCartDataDelivery.mcp_intervention_date == ""); // add item so cart is not empty so customer info can be retrieved -_-, clean cart only if intervention not already selected (close modal then reopen)
      this.openModalCalendar();
    }, { passive: true });
    
  },

  methods: {
    openModalCalendar () {
      this.showModalCalendar = true;
    },
    closeModalCalendar () {
      this.showModalCalendar = false;
    },
    ...mapActions({ initStrapiForm: "initStrapiForm" }),
  },
};
</script>
